import PostMessageHelper from '@eig-builder/core-utils/helpers/post-message-helper'
import { ADD_PRODUCT_TO_CART, UPDATE_SETTINGS, GET_INSIGHTS_IDENTITY, CLEAR_SHOPPING_CART } from './../store/constants'
import * as messageTypes from 'core/sdk-communication/enums/message-types'
import * as applicationTypes from 'core/sdk-communication/enums/application-types'
import Store from '@eig-builder/core-utils/store'

export default class SdkCommunicationHelper {
  constructor () {
    this.postMessageHandler = new PostMessageHelper()
    this.postMessageHandler.bind(messageTypes.GetSettings, message => {
      const { data } = message

      if (message.targets && message.targets.indexOf(applicationTypes.ShoppingCart) !== -1) {
        Store().dispatch({
          type: UPDATE_SETTINGS,
          body: data
        })
      }
    })
    this.postMessageHandler.bind(messageTypes.GetIdentity, message => {
      const { data } = message

      if (message.targets && message.targets.indexOf(applicationTypes.ShoppingCart) !== -1) {
        Store().dispatch({
          type: GET_INSIGHTS_IDENTITY,
          body: data
        })
      }
    })
    this.postMessageHandler.bind(messageTypes.AddToCart2, message => {
      const { data } = message
      const { callbackApplicationType, callbackMessageType, productId, quantity, skuId, propertyBag } = data
      console.log(callbackApplicationType, callbackMessageType, productId, quantity, skuId)

      Store().dispatch({
        type: ADD_PRODUCT_TO_CART,
        body: {
          productId,
          variantId: skuId,
          quantity,
          propertyBag
        }
      })

      window.parent.postMessage({ targets: callbackApplicationType, type: callbackMessageType }, '*')
    })
    this.postMessageHandler.bind(messageTypes.CheckoutFinished, message => {
      this.closeShoppingCart()
      Store().dispatch({
        type: CLEAR_SHOPPING_CART
      })
      this.updateCartLabelAndPrice(0, 0)
    })
    this.postMessageHandler.bind(messageTypes.ClearCartContents, message => {
      Store().dispatch({
        type: CLEAR_SHOPPING_CART
      })
    })
  }

  closeShoppingCart () {
    window.parent.postMessage({ targets: 'server', type: messageTypes.ShoppingCartClose }, '*')
  }

  updateCartLabelAndPrice (itemsCount, price) {
    window.parent.postMessage(
      {
        targets: 'label',
        type: messageTypes.SetCartLbl,
        data: {
          price: price,
          count: itemsCount
        }
      },
      '*'
    )
  }

  cartFinishedLoading () {
    window.parent.postMessage({ targets: 'label', type: messageTypes.CartFinishedLoading }, '*')
  }

  getSettings () {
    window.parent.postMessage({ targets: 'server', type: messageTypes.GetSettings }, '*')
  }

  getIdentity () {
    window.parent.postMessage({ targets: 'server', type: messageTypes.GetIdentity }, '*')
  }

  destroy () {
    this.postMessageHandler.clear()
  }
}
